// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"02797eb5","586":"a2780dc6"}[chunkId] + ".chunk.css";
};